export default __webpack_public_path__ + "static/media/8_Ginger-Bells.e47d59cd.png";